import { useState } from "react";
import { Categories } from "../VideoCategories";
import styles from "../../../styles/Videos/Mobile/MobileVideoCategory.module.css";

const MobileVideoCategory = ({ clickedPlaylist }) => {
  const [currentIndex, setCurrentIndex] = useState(0);


  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % Categories.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? Categories.length - 1 : prevIndex - 1
    );
  };

  const currentCategory = Categories[currentIndex];

  return (
    <div className={styles.videoCategoryContainer}>
      <div className={styles.videoCategoryInnerContainer}>
        <div className={styles.categoryHeader}>
          <div className={styles.categoriesTitle}>Categories</div>
          <div className={styles.categoriesNav}>
            <span onClick={handlePrev} style={{ cursor: "pointer" }}>
              <img src="/red_arrow_circle_left.svg" alt="left_icon" />
            </span>
            <span onClick={handleNext} style={{ cursor: "pointer" }}>
              <img src="/red_arrow_circle_right.svg" alt="right_icon" />
            </span>
          </div>
        </div>
        {currentCategory && (
          <div
            className={styles.categoryContainer}
            onClick={() => clickedPlaylist(currentCategory)}
          >
            <div className={styles.categoryImageContainer}>
              <img src={currentCategory.thumbnail} alt="category-icon" />
            </div>
            <div className={styles.categoryDescContainer}>
              <div className={styles.currentCategoryTitle}>
                {currentCategory.title}
              </div>
              <div className={styles.currentCategoryWatched}>Watched</div>
              <div className={styles.currentCategoryDesc}>
                {currentCategory.description}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileVideoCategory;
